export enum ReportTabType {
    GenerateReport,
    CustomReport,
    ReportHistory,
    UserReports
}